import Breadcrumbs from './breadcrumbs';

export default Breadcrumbs;
